import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const HelpIllustration = ({ title, width = 40, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    title={title}
    width={width}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFBF00"
          d="M20 0C8.953 0 0 8.953 0 20c0 11.048 8.953 20 20 20V0zM20 0v40c3.88 0 7.497-1.108 10.564-3.019l8.769 2.35-2.35-8.77C38.893 27.496 40 23.878 40 20 40 8.953 31.045 0 20 0z"
        />
        <path
          fill="#2A2E2D"
          d="M22.215 24.06h-3.96l-.06-.803c-.06-1.576.42-3.183 1.77-4.851.96-1.175 1.74-2.194 1.74-3.214 0-1.082-.69-1.823-2.16-1.854-1.02 0-2.19.34-3 .927l-.99-3.368c1.08-.65 2.85-1.267 5.01-1.267 3.93 0 5.76 2.255 5.76 4.79 0 2.379-1.44 3.924-2.58 5.222-1.08 1.267-1.56 2.472-1.53 3.862v.557zm-2.07 7.108h-.03c-1.59 0-2.67-1.205-2.67-2.812 0-1.669 1.11-2.812 2.67-2.812 1.62 0 2.67 1.143 2.7 2.812 0 1.607-1.05 2.812-2.67 2.812z"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M20 0v40c3.88 0 7.497-1.108 10.564-3.019l8.769 2.35-2.35-8.77C38.893 27.496 40 23.878 40 20 40 8.953 31.045 0 20 0z"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
